








import { Component, Vue } from "vue-property-decorator";
import { Console, Events } from "@/common/global.ts";

@Component
export default class CloseButton extends Vue {

    private Handle_OnClickClose(e: MouseEvent): void {
        history.back();
    }

}
